<fin-shopping-cart-line-item
  [count]="count()"
  [icon]="icon()"
  [title]="title()"
  [titleKey]="titleKey()"
  [titleParams]="titleParams()"
  [price]="price()"
  [accentPrice]="isBundle()"
/>
@for (child of childRows(); track child.titleKey ?? child.title ?? $index) {
  <fin-shopping-cart-line-item
    [count]="child.count"
    [title]="child.title"
    [titleKey]="child.titleKey"
    [titleParams]="child.titleParams"
    [indented]="true"
  />
}
